import { Radio, Space, Tooltip } from 'antd';
import type * as React from 'react';
import styled from 'styled-components';

const StyledRadioButtons = styled(Radio.Button)`
  &.ant-radio-button-wrapper {
    padding-inline: 8px;
  }
`;

export interface IMapDrawingRadioButtonProps {
  isMobile?: boolean | null;
  label?: string;
  value: string;
  icon?: React.ReactNode;
}

export function MapDrawingRadioButton(props: IMapDrawingRadioButtonProps) {
  const { isMobile, label, value, icon, ...otherProps } = props;

  return (
    <Tooltip title={label} open={!isMobile ? false : undefined}>
      <StyledRadioButtons value={value} {...otherProps}>
        <Space>
          {icon}
          {!isMobile && label}
        </Space>
        {isMobile && <span className={'sr-only'}>{label}</span>}
      </StyledRadioButtons>
    </Tooltip>
  );
}
